const navItems = [
    {
        href: '#managed-campaigns',
        emoji: '🤝',
        label: 'Managed Campaigns',
    },
    {
        href: '#mailing-lists-data',
        emoji: '🗂️',
        label: 'Mailing Lists & Data',
    },
    {
        href: '#strategy-creative',
        emoji: '🧠',
        label: 'Strategy & Creative',
    },
    {
        href: '#response-tracking',
        emoji: '📊',
        label: 'Response Tracking',
    },
    {
        href: '#high-volume-programs',
        emoji: '📈',
        label: 'For High-Volume Mailers',
    },
]

export default function ServicesJumpNav() {
    return (
        <div className="sticky top-0 z-[1] border-b border-black/10 bg-white">
            <div className="container mx-auto flex gap-1 overflow-x-auto px-4 scrollbar-hide md:px-0 xl:px-0">
                {navItems.map((item) => (
                    <a
                        key={item.href}
                        href={item.href}
                        className="inline-flex whitespace-nowrap items-center gap-2 border-b-2 border-transparent px-[14px] py-4 text-[13px] font-medium text-[#6F7785] transition hover:text-[#1F2937]">
                        <span className="text-[14px]">{item.emoji}</span>
                        <span>{item.label}</span>
                    </a>
                ))}
            </div>
        </div>
    )
}
